export default "__VITE_ASSET__Cglax2mw__"